import * as yup from 'yup';
import moment from 'moment';

import { Utils } from '@eisc-frontend/shared-ui';

const richTextContentValidation = (config) => {
  return yup
    .mixed()
    .required(config.EMPTY_RICH_TEXT_ERROR_MESSAGE)
    .transform((richTextInput) => {
      return Utils.richTextContentToPlainText(richTextInput);
    })
    .test('transformation', config.TRANSFORMATION_ERROR_MESSAGE, (value) => {
      return !(value instanceof Error);
    })
    .test('string type', config.TYPE_ERROR_MESSAGE, (value) => {
      return typeof value === 'string' || value instanceof String;
    })
    .test('non-empty richText content', config.EMPTY_RICH_TEXT_CONTENT_ERROR_MESSAGE, (value) => {
      return Boolean(value);
    })
    .test('max length', `Must be ${config.max} characters or less`, (value) => {
      return value?.length < config.max;
    });
};

export const AddReplySchema = yup.object().shape({
  organizationId: yup.string().optional().nullable(),
  proponentId: yup.string().required('Reviewer is required').nullable(),
  description: richTextContentValidation({
    max: 30000,
    TRANSFORMATION_ERROR_MESSAGE: 'Rich Text parsing error',
    TYPE_ERROR_MESSAGE: 'Description should be a string',
  }),
  parentId: yup.string(),
  commentId: yup.string(),
  status: yup.string(),
  attachments: yup.array(),
});

export const StaffInternalDataSchema = yup.object().shape({
  informationRequestDueAt: yup
    .string()
    .required('Information request deadline is a required field')
    .when('commentDueAt', (commentDueAt, schema) => {
      return schema.test(
        'informationRequestDueAt',
        'Information request deadline cannot be in future to comments due date',
        (value) => !(commentDueAt && moment(commentDueAt).diff(value, 'days') < 0),
      );
    }),
  itemDistributedAt: yup
    .string()
    .when('informationRequestDueAt', (informationRequestDueAt, schema) => {
      return schema.test(
        'itemDistributedAt',
        'Project distributed date must not be after information request due date.',
        (value) =>
          !(informationRequestDueAt && moment(informationRequestDueAt).diff(value, 'days') < 0),
      );
    })
    .when('informationRequestDueAt', (commentDueAt, schema) => {
      return schema.test(
        'itemDistributedAt',
        'Project distributed date must not be after information request due date.',
        (value) => !(commentDueAt && moment(commentDueAt).diff(value, 'days') < 0),
      );
    }),
  commentDueAt: yup.string().required('Comment deadline is a required field'),
});
